import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import MainContent from "@/views/MainContent.vue";

const routes = [
  {
    path: "/",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),

    beforeEnter: () => {
      if (store.getters.accountToken) {
        return "dashboard";
      }
    },
  },

  {
    path: "/dashboard",
    name: "dashboard",
    component: MainContent,
  },

  {
    path: "/farm/:id",
    name: "farm",
    component: MainContent,
  },

  {
    path: "/dashboard",
    name: "dashboard",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/MainContent.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
